module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ard-wrap"
  }, [_c('modal', {
    staticClass: "ard-modal",
    attrs: {
      "name": "addRace",
      "adaptive": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 620
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "ard-dialog"
  }, [_c('div', {
    staticClass: "ard-dialog-header"
  }, [_c('div', {
    staticClass: "ard-dialog-header-left"
  }, [_c('span', {
    staticClass: "ard-dialog-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 5v14M5 12h14"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "ard-dialog-title"
  }, [_vm._v("Add Race")]), _vm._v(" "), _c('p', {
    staticClass: "ard-dialog-sub"
  }, [_vm._v("Attach this runner to a race and set the starting distance")])])]), _vm._v(" "), _c('button', {
    staticClass: "ard-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('addRace')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ard-dialog-body"
  }, [_c('label', {
    staticClass: "ard-field"
  }, [_c('span', {
    staticClass: "ard-label"
  }, [_vm._v("Race Id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.raceId),
      expression: "raceId"
    }],
    staticClass: "ard-input",
    attrs: {
      "type": "number",
      "name": "raceId",
      "placeholder": "Enter race id"
    },
    domProps: {
      "value": (_vm.raceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.raceId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "ard-field"
  }, [_c('span', {
    staticClass: "ard-label"
  }, [_vm._v("Distance")]), _vm._v(" "), _c('div', {
    staticClass: "ard-input-unit"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newdistance),
      expression: "newdistance"
    }],
    staticClass: "ard-input",
    attrs: {
      "type": "number",
      "name": "newdistance",
      "placeholder": "0.00"
    },
    domProps: {
      "value": (_vm.newdistance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newdistance = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ard-unit"
  }, [_vm._v("Km")])])]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "ard-error"
  }, [_vm._v("Not a valid Race Id !")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ard-dialog-footer"
  }, [_c('button', {
    staticClass: "ard-cancel-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('addRace')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ard-save-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.Save(_vm.raceId, _vm.newdistance)
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-837aa63a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/AddRaceData.vue
// module id = 1739
// module chunks = 2